import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { RouterModule, PreloadAllModules } from '@angular/router';

import { ENV_PROVIDERS } from './environment';
import { ROUTES } from './app.routes';

import { AppComponent } from './app.component';

import { NotificationModule } from './components/shared/notification/notification.module';

// vendor
import { ReCaptchaModule } from 'angular2-recaptcha';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { SharedModule } from './shared/shared.module';

// shared components
import { NavbarComponent } from './components/shared/navbar/navbar.component';
import { NavbarClientComponent } from './components/shared/navbar/client/navbar-client.component';
import { NavbarGuestComponent } from './components/shared/navbar/guest/navbar-guest.component';
import { CookiebarComponent } from './components/shared/cookiebar/cookiebar.component';
import { ErrorComponent } from './components/error/error.component';
import { RootComponent } from './components/error/root.component';

// application modals (maybe can be removed when all is stable)
// navbar modals
import { StatusModalComponent } from './components/shared/navbar/client/modals/status/status-modal.component';

// modal components
// client modals
import { HackResultModalComponent } from './components/client/shared/modals/hack-result/hack-result-modal.component';
import { JobDescriptionModalComponent } from './components/client/shared/modals/job-description/job-description-modal.component';

// services
import { AuthService } from './providers/auth.service';
import { ClientPingService } from './providers/client-ping.service';
import { AuthHttpClient } from './providers/auth-http.service';
import { AuthHttpDynamic } from './providers/auth-http-dynamic.service';
import { PublicHttpService } from './providers/public-http.service';
import { CookieService } from './providers/cookie.service';
import { AuthGuardClientService } from './providers/auth-guard-client.service';
import { FileHelper } from './providers/file.service';
import { TimezoneGuardService } from './providers/timezone-guard.service';
import { TimeService } from './shared/services/time.service';

import { SharedClientService } from './components/client/shared/services/shared-client.service';
import { SharedThirdPartyIntegrationService } from './components/client/shared/services/shared-third-party-integration.service';
import { SharedClientCandidateService } from './components/client/shared/services/shared-candidate.service';
import { SharedJobService } from './components/client/shared/services/shared-job.service';
import { SharedExportService } from './components/client/shared/services/shared-export.service';
import { SharedHackService } from './components/client/shared/services/shared-hack.service';

// public services
import { PublicJobService } from './public/services/public-job.service';

// Bootstrap JS
import 'bootstrap/dist/js/bootstrap.min';

// chosen-js
import 'chosen-js';

// Tinymce
import 'tinymce/tinymce';
import 'tinymce/themes/modern/theme';

// tinymce Plugins
import 'tinymce/plugins/paste/plugin';
import 'tinymce/plugins/link/plugin';
import 'tinymce/plugins/lists/plugin';
import 'tinymce/plugins/preview/plugin';
import 'tinymce/plugins/searchreplace/plugin';
import 'tinymce/plugins/fullscreen/plugin';
import 'tinymce/plugins/media/plugin';
import 'tinymce/plugins/wordcount/plugin';
import 'tinymce/plugins/code/plugin';
import 'tinymce/plugins/insertdatetime/plugin';
import 'tinymce/plugins/contextmenu/plugin';
import 'tinymce/plugins/autoresize/plugin';

// jquery knob
import 'jquery-knob/dist/jquery.knob.min.js';

// prettify js
import 'assets/vendor/prettify/prettify.js';

import '../styles/styles.scss';
import { PosthogService } from './providers/posthog.service';
import { AppService } from './shared/services/app.service';
import { CodeSampleModule } from './components/client/shared/components/code-sample.module';
import { ShowdownModule } from './components/client/shared/components/showdown.module';
import { HackResultsViewerModule } from './components/client/shared/components/hack-results-viewer/hack-results-viewer.module';
import { AtsConfigModalComponent } from './components/client/settings/modals/ats-config-modal/ats-config-modal.component';

export function appServiceFactory(appInitService: AppService) {
	return () => appInitService.init();
}



export class AppModule {
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/app.module.ts